import { COLORS } from 'helpers/globals'

export default {
  container: {
    '& input': { marginBottom: '1rem' },
    '& button': { fontSize: '1.4rem' }
  },
  '@keyframes spin': {
    '100%': { transform: 'rotate(360deg)' }
  },
  loadingIcon: {
    color: 'white',
    animation: 'spin 4s linear infinite'
  },
  errorMessage: {
    marginLeft: '1rem',
    color: 'red'
  },
  forgotPasswordButton: {
    color: '#416CAD',
    textDecoration: 'none',
    fontSize: '1.4rem',
    textAlign: 'left',
    '&:hover': { color: '' },
    lineHeight: '2.2em',
    marginTop: '1rem'
  },
  buttons: {
    float: 'right',
    marginBottom: '2rem',
    '& button': { marginLeft: '.5rem' }
  },
  closeButton: {
    background: COLORS.quaternary,
    '&:hover': {
      background: COLORS.quaternaryHover
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/LoginForm/style.js